import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { visit } from 'unist-util-visit';


export const addFootnoteIndex = () => (tree) => {
  // Add a per-node property 'indexes' to the given node tree for footnotes.
  let idx = 1;

  visit(tree, 'element', (node, _, parent) => {
    // If the element is a <cite> element and has valid authors
    if (node.tagName === 'footnote') {
      node.properties.index = idx;
      idx += 1;
    };
  });
};


export function getFootnoteLabel(idx){
  // Create a linkable ID. We can reuse the code for headings.
  return `#footnote-label-${idx}`; 
}


const FootnoteLabel = ({children, node}) => {

  const [wasClicked, setWasClicked] = useState(false);
  const location = useLocation();
  const slug = getFootnoteLabel(node.properties.index)

  useEffect(() => {
    // Check if the URL contains a hash with an ID.
    // Executes when this page is opened using a link that contains an ID hash, e.g. /projects##musio.
    if (location.hash) {
      if (location.hash === `#${slug}`) {
        setWasClicked(true);
      }
    }
  }, [location]);

  return (
    <span id={slug}>
        <sup className={`text-theme-turquoise dark:text-theme-orange group ${wasClicked ? 'border border-theme-turquoise dark:border-theme-orange' : ''}`}>
          {/* <div className={wasClicked ? 'border border-theme-turquoise dark:border-theme-orange' : ''}>{node.properties.index}</div> */}
          <span className='font-bold'>{node.properties.index}</span>
          <div 
            className="absolute top-6 border-2 rounded border-theme-turquoise dark:border-theme-orange bg-light dark:bg-dark-accent bg-opacity-50 backdrop-blur-md invisible group-hover:visible hover:visible ease-out duration-200 z-50"
            // The text is 576px wide on desktop and has 2*20px margins on mobile.
            style={{width: `${Math.min(576, window.innerWidth - 40)}px`}}
          >
            <span className='flex flex-col text-xs md:text-sm m-2'>
              {/* <span className='font-bold'>Footnote</span> */}
              <span className='text-dark-accent dark:text-light-accent'>{children}</span>
            </span>
          </div>
        </sup>
    </span>
  )
};

export default FootnoteLabel
